module.exports = __webpack_public_path__ + "img/seo_glotto_item03.1b848a1.webp";